<template>
  <div id="app">
    <nav id="nav">
      <div>
        <router-link to="/">Home</router-link>
        <router-link to="/pics">Pictures</router-link>
        <router-link to="/cook">Cooking</router-link>
      </div>
    </nav>
    <main>
      <router-view></router-view>
    </main>
  </div>
</template>

<script>
export default {
  name: 'app'
}
</script>
<style lang="scss">
@import url('https://fonts.googleapis.com/css2?family=Roboto&display=swap');
@font-face {
  font-family: "NexaLight";
  src: url(./fonts/NexaLight.otf);
}
* {
  font-family: NexaLight;
}
body {
  margin: 0;
  padding: 0;
  background-color: rgb(76, 55, 88);
  font-family: NexaLight;
}

#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  margin-top: 80px;
}

main {
  text-align: center;
  margin-top: 40px;
}

#nav {
  display: flex;
  top: 0;
  justify-content: center;
  position: fixed;
  width: 100%;
  background-color: #00000088;
  div {
    display: flex;
    max-width: 1600px;
    width: 100%;
    justify-content: end;
    a {
      padding: 1em;
      text-decoration: none;
      color: white;
      transition-duration: 0.2s;
      &:hover {
        background-color: rgb(141, 97, 39);
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/App.vue